export default "__VITE_ASSET__BG_rs_s___"